export default __webpack_public_path__ + "static/media/transfer-list-bg.253b001c.png";